// src/services/anprAlarm.api.ts

import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { ApiResponse } from 'http/types/api-response'
import { AlarmConfiguration } from 'domain/alarm-configuration'
import { AlarmConfigurationList } from '../types/alarm-configuration-response'
import { AlarmEventList } from '../types/alarm-event-list-response'
import { AlarmQueryParams } from '../types/alarm-query-params'
import { APIAlarmCriteria } from '../types/api-alarm-criteria'

class ANPRAlarmApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.alarms
  }

  public async getAlarmConfigurations(
    params?: AlarmQueryParams
  ): Promise<AlarmConfigurationList> {
    return apiService.get<AlarmConfigurationList>(
      this.baseUrl + `/configurations/${params?.clientId}`
    )
  }

  public async createAlarmConfiguration(
    clientId: string | null,
    alarmConfigData: AlarmConfiguration
  ): Promise<ApiResponse<AlarmConfiguration>> {
    return apiService.post<ApiResponse<AlarmConfiguration>>(
      this.baseUrl + `/configurations/${clientId}`,
      alarmConfigData
    )
  }

  public async getANPRAlarmCriteria(): Promise<APIAlarmCriteria[]> {
    return apiService.get<APIAlarmCriteria[]>(this.baseUrl + `/criteria/anpr`)
  }

  public async getAHCRAlarmCriteria(): Promise<APIAlarmCriteria[]> {
    return apiService.get<APIAlarmCriteria[]>(this.baseUrl + `/criteria/ahcr`)
  }

  public async deleteAlarmConfiguration(id: string): Promise<void> {
    return apiService.delete<void>(this.baseUrl + `/configurations/${id}`)
  }

  public async getAlarmEvents(
    params?: AlarmQueryParams
  ): Promise<AlarmEventList> {
    return apiService.get<AlarmEventList>(
      this.baseUrl + `/events/${params?.clientId}`
    )
  }

  public async deleteAlarmEvent(id: string): Promise<void> {
    return apiService.delete<void>(this.baseUrl + `/events/${id}`)
  }
}

export const anprAlarmApiService = new ANPRAlarmApiService()
export default anprAlarmApiService
